import React, { useMemo } from 'react';
import { LISTING_ENGINE_FUEL_TYPE } from '../../../constants/listing.constants';
import { useIntl } from 'react-intl';
import DropdownFilter from '../DropdownFilter/DropdownFilter';

import css from './SearchPageStyles.module.css';

const fuelTypes = Object.values(LISTING_ENGINE_FUEL_TYPE);

const SEARCH_PARAM_NAME = 'fuelType';

const FuelTypeFilter = () => {
  const intl = useIntl();

  const fuelTypeDropdownOptions = useMemo(
    () =>
      fuelTypes.map(fuelType => ({
        value: fuelType,
        label: intl.formatMessage({ id: `General.listing.fuelType.${fuelType}` }),
        searchString: intl.formatMessage({ id: `General.listing.fuelType.${fuelType}` }),
      })),
    []
  );

  return (
    <DropdownFilter
      options={fuelTypeDropdownOptions}
      searchParamName={SEARCH_PARAM_NAME}
      placeholder={intl.formatMessage({ id: 'EditListingDetailsForm.fuelType' })}
      classNameLabel={css.dropdownLabel}
      disableFiltering
      searchable
    />
  );
};

export default FuelTypeFilter;
